export default {
  namespaced: true,
  state: {
    appointmentPanel: false
  },
  getters: {
    APPOINTMENT_PANEL: state => {
      return state.isPolyclinicSummary;
    }
  },
  mutations: {
    setAppointmentPanel(state, flag) {
      state.appointmentPanel = flag;
    }
  },
  actions: {
    setAppointmentPanel(context, payload) {
      context.commit("setAppointmentPanel", payload);
    }
  }
};
